// BLOG
export const GET_BLOG_LIST = 'blog/GET_BLOG_LIST';
export const GET_BLOG_LIST_TOTAL_RECORDS = 'blog/GET_BLOG_LIST_TOTAL_RECORDS';
export const GET_BLOG_BY_ID = 'blog/GET_BLOG_BY_ID';
export const GET_RELATED_POSTS = 'blog/GET_RELATED_POSTS';
export const CLEAR_BLOG_DATA = 'blog/CLEAR_BLOG_DATA';

// VACANCIES
export const GET_VACANCY_LIST = 'vacancy/GET_VACANCY_LIST';
export const GET_VACANCY_LIST_TOTAL_RECORDS = 'vacancy/GET_VACANCY_LIST_TOTAL_RECORDS';
export const GET_VACANCY_BY_ID = 'vacancy/GET_VACANCY_BY_ID';
export const CLEAR_VACANCY_DATA = 'vacancy/CLEAR_VACANCY_DATA';
